import { render, staticRenderFns } from "./OaCalendarList.vue?vue&type=template&id=9c23d7a0&scoped=true"
import script from "./OaCalendarList.vue?vue&type=script&lang=js"
export * from "./OaCalendarList.vue?vue&type=script&lang=js"
import style0 from "./OaCalendarList.vue?vue&type=style&index=0&id=9c23d7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c23d7a0",
  null
  
)

export default component.exports